import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import { useDispatch } from 'react-redux';
import { post } from '../../Services/http';
import { catchError } from '../../Actions/Error.action';

const UpsellProducts = ({ ownerVariantId, lightSources, lampPlugs, quantityFieldId }) => {
    const refLampList = useRef(null);
    const refLampSelect = useRef(null);
    const refSourceList = useRef(null);
    const refSourceSelect = useRef(null);
    const [lightSourceId, setLightSource] = useState(null);
    const [lampPlugId, setLampPlug] = useState(null);
    const dispatch = useDispatch();
    const refplug = useRef(null);
    const refsource = useRef(null);

    document.addEventListener('click', function (event) {
        if (refplug.current && !refplug.current.contains(event.target)) {
            if (refLampList.current.classList.contains('dropdown__block-select-list--show')) {
                refLampList.current.classList.toggle('dropdown__block-select-list--show');
            }
        }
        if (refsource.current && !refsource.current.contains(event.target)) {
            if (refSourceList.current.classList.contains('dropdown__block-select-list--show')) {
                refSourceList.current.classList.toggle('dropdown__block-select-list--show');
            }
        }
    });

    const onLightSourceChange = (value, text) => {
        setLightSource(value);
        refSourceList.current.classList.toggle('dropdown__block-select-list--show');
        refSourceSelect.current.innerText = text;
    };
    const onLampPlugChange = (value, text) => {
        setLampPlug(value);
        refLampList.current.classList.toggle('dropdown__block-select-list--show');
        refLampSelect.current.innerText = text;
    };
    const productQuantityElement = document.getElementById(quantityFieldId);

    useEffect(() => {
        const updatePrice = () => {
            const productQuantity = productQuantityElement ? quantityFieldId.value : '1';
            post('/api/product-upsell', {
                parentId: ownerVariantId,
                lightSourceId,
                lampPlugId,
                productQuantity,
            })
                .then((response) => response.json())
                .then((result) => {
                    var priceElement = document.querySelector('.product-detail__price-info .price_span');
                    priceElement.textContent = result.formattedCampaignPrice ? result.formattedCampaignPrice : result.formattedPrice;
                    var priceElementOldPrice = document.querySelector('.product__old-price');
                    if (priceElementOldPrice !== null) {
                        priceElementOldPrice.textContent = result.formattedPrice;
                    }
                    var buyButton = document.querySelector('buy-button');
                    buyButton.setAttribute('data-lightsourceid', result.lightSourceId ?? '');
                    buyButton.setAttribute('data-lightplugid', result.lampPlugId ?? '');
                    buyButton.setAttribute('data-lightplugquantity', result.lampPlugId ? '1' : '0');
                    buyButton.setAttribute('data-lightsourcequantity', result.lightSourceId ? result.lightSourceQuantity : '0');
                })
                .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
        };

        if (lightSourceId !== null || lampPlugId !== null) {
            updatePrice();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lightSourceId, lampPlugId]);

    return (
        <div className="upsell-product-selector">
            {lightSources && lightSources.length > 0 && (
                <div ref={refsource} className="dropdown">
                    <div className="dropdown__block-title">{translate(`product.LightSourceRelationShipSelectCaption`)}</div>
                    <div>
                        <div
                            onClick={() => refSourceList.current.classList.toggle('dropdown__block-select-list--show')}
                            ref={refSourceSelect}
                            className="dropdown__block-select"
                        >
                            {translate('product.LightSourceRelationShipSelectLabel')}
                        </div>
                        <ul ref={refSourceList} className="dropdown__block-select-list" title={translate('product.LightSourceRelationShipSelectLabel')}>
                            <li
                                className="dropdown__block-select-list-item"
                                onClick={() => onLightSourceChange('', translate('product.LightSourceRelationShipSelectLabel'))}
                            >
                                {translate('product.LightSourceRelationShipSelectLabel')}
                            </li>
                            {lightSources.map((src, index) => (
                                <li className="dropdown__block-select-list-item" onClick={() => onLightSourceChange(src.id, src.name)} key={index}>
                                    {src.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
            {lampPlugs && lampPlugs.length > 0 && (
                <div ref={refplug} className="dropdown">
                    <div className="dropdown__block-title">{translate(`product.LampPlugsRelationShipSelectCaption`)}</div>
                    <div>
                        <div
                            onClick={() => refLampList.current.classList.toggle('dropdown__block-select-list--show')}
                            ref={refLampSelect}
                            className="dropdown__block-select"
                        >
                            {translate('product.LampPlugsRelationShipSelectLabel')}
                        </div>
                        <ul ref={refLampList} className="dropdown__block-select-list" title={translate('product.LampPlugsRelationShipSelectLabel')}>
                            <li
                                className="dropdown__block-select-list-item"
                                onClick={() => onLampPlugChange('', translate('product.LampPlugsRelationShipSelectLabel'))}
                            >
                                {translate('product.LampPlugsRelationShipSelectLabel')}
                            </li>
                            {lampPlugs.map((src, index) => (
                                <li className="dropdown__block-select-list-item" onClick={() => onLampPlugChange(src.id, src.name)} key={index}>
                                    {src.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UpsellProducts;
